export default __webpack_public_path__ + "static/media/28.99a236fe.jpg";